import type {PredictionBatchSource} from 'constants/AnalyticsConstants';
import {getApolloClient} from 'graphql-client/ApolloClient';
import {REMAINING_EXECUTIONS_AND_TENANT_NAME_QUERY} from 'molbio/aa-sequences/alphafold/AlphaFoldTabUtils';
import notifications from 'notifications';
import * as net from 'util/Net';

import {BoltzGenInput} from './GenerativeModelsConstants';

export async function runBoltzGen(inputs: BoltzGenInput, source?: PredictionBatchSource): Promise<boolean> {
  try {
    await net.postJSONPromise({
      url: '/1/api/model-hub/generative-models/boltzgen',
      data: {...inputs, source},
    });
    getApolloClient().refetchQueries({include: [REMAINING_EXECUTIONS_AND_TENANT_NAME_QUERY]});
    return true;
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (error) {
    notifications.notifyError(error);
    return false;
  }
}
